<div class="mfa-challenge">
	<h2 mat-dialog-title>Verify Your Identity</h2>

	<mat-dialog-content>
		<!-- Loading -->
		<div *ngIf="currentStep === 'loading'" class="challenge-step loading-step">
			<mat-spinner diameter="40"></mat-spinner>
			<p>Preparing verification...</p>
		</div>

		<!-- Email OTP -->
		<div *ngIf="currentStep === 'email-otp'" class="challenge-step">
			<p class="step-description">
				A verification code has been sent to <strong>{{ data.maskedEmail }}</strong>.
			</p>

			<mat-form-field appearance="outline" class="code-field">
				<mat-label>6-digit code</mat-label>
				<input matInput
					   [(ngModel)]="code"
					   maxlength="6"
					   pattern="[0-9]*"
					   inputmode="numeric"
					   autocomplete="one-time-code"
					   (keyup.enter)="verifyCode()"
				   (input)="sanitizeCode($event)" />
			</mat-form-field>

			<div class="countdown-row" *ngIf="otpExpiresAt && otpCountdown > 0">
				<mat-icon>timer</mat-icon>
				<span>Code expires in {{ formattedCountdown }}</span>
			</div>

			<div class="resend-row">
				<button mat-button
						class="resend-link"
						[disabled]="!canResend || isSubmitting"
						(click)="resendCode()">
					{{ resendCountdown > 0 && !isOtpExpired ? 'Resend code (' + resendCountdown + 's)' : 'Resend code' }}
				</button>
			</div>

			<div class="switch-method-row" *ngIf="canSwitchMethod">
				<button mat-stroked-button
						class="switch-method-button"
						[disabled]="isSubmitting"
						(click)="switchMethod()">
					{{ switchMethodLabel }}
				</button>
			</div>

			<div class="cancel-switch-row" *ngIf="isOnAlternativeMethod">
				<button mat-button
						class="cancel-switch-link"
						[disabled]="isSubmitting"
						(click)="cancelSwitch()">
					{{ cancelSwitchLabel }}
				</button>
			</div>
		</div>

		<!-- TOTP -->
		<div *ngIf="currentStep === 'totp'" class="challenge-step">
			<p class="step-description">Enter the 6-digit code from your authenticator app.</p>

			<mat-form-field appearance="outline" class="code-field">
				<mat-label>6-digit code</mat-label>
				<input matInput
					   [(ngModel)]="code"
					   maxlength="6"
					   pattern="[0-9]*"
					   inputmode="numeric"
					   autocomplete="one-time-code"
					   (keyup.enter)="verifyCode()"
					   (input)="sanitizeCode($event)" />
			</mat-form-field>

			<div class="switch-method-row" *ngIf="canSwitchMethod">
				<button mat-stroked-button
						class="switch-method-button"
						[disabled]="isSubmitting"
						(click)="switchMethod()">
					{{ switchMethodLabel }}
				</button>
			</div>

			<div class="cancel-switch-row" *ngIf="isOnAlternativeMethod">
				<button mat-button
						class="cancel-switch-link"
						[disabled]="isSubmitting"
						(click)="cancelSwitch()">
					{{ cancelSwitchLabel }}
				</button>
			</div>
		</div>

		<!-- Contact Administrator -->
		<div *ngIf="currentStep === 'contact-admin'" class="challenge-step contact-admin-step">
			<mat-icon class="lockout-icon">lock</mat-icon>
			<h3>Account Locked</h3>
			<p>You've exceeded the maximum number of verification attempts.</p>

			<div class="contact-info" *ngIf="contactAdminPhoneEnabled || contactAdminEmailEnabled">
				<p class="contact-label">Contact your administrator for assistance:</p>
				<div class="contact-item" *ngIf="contactAdminPhoneEnabled && contactAdminPhone">
					<mat-icon>phone</mat-icon>
					<span>{{ contactAdminPhone }}</span>
				</div>
				<div class="contact-item" *ngIf="contactAdminEmailEnabled && contactAdminEmail">
					<mat-icon>email</mat-icon>
					<a [href]="'mailto:' + contactAdminEmail">{{ contactAdminEmail }}</a>
				</div>
			</div>

			<p *ngIf="!contactAdminPhoneEnabled && !contactAdminEmailEnabled" class="contact-fallback">
				Contact your administrator for help accessing your account.
			</p>
		</div>

		<!-- Success -->
		<div *ngIf="currentStep === 'success'" class="challenge-step success-step">
			<mat-icon class="success-icon">check_circle</mat-icon>
			<h3>Verification successful</h3>
		</div>

		<!-- Attempts Remaining -->
		<div *ngIf="attemptsRemaining != null && !isTerminalStep" class="attempts-info">
			{{ attemptsRemaining }} attempt{{ attemptsRemaining !== 1 ? 's' : '' }} remaining
		</div>

		<!-- Error Message -->
		<div *ngIf="errorMessage" class="error-message">
			<mat-icon>error_outline</mat-icon>
			<span>{{ errorMessage }}</span>
		</div>
	</mat-dialog-content>

	<mat-dialog-actions align="end">
		<!-- Cancel button (customer switch only) -->
		<button mat-button
				*ngIf="(data.custId != null || data.mode === 'reauth') && !isTerminalStep"
				[disabled]="isSubmitting"
				(click)="dialogRef.close({ success: false })">
			Cancel
		</button>

		<!-- H5: Sign out — the only exit on the login-mode challenge (no custId / not reauth), which is disableClose. -->
		<button mat-button
				*ngIf="data.custId == null && data.mode !== 'reauth' && !isTerminalStep"
				[disabled]="isSubmitting"
				(click)="signOut()">
			Sign out
		</button>

		<!-- Verify button -->
		<button mat-raised-button color="primary"
				*ngIf="currentStep === 'email-otp' || currentStep === 'totp'"
				[disabled]="isSubmitting || !code || code.length !== 6 || isOtpExpired"
				(click)="verifyCode()">
			{{ isSubmitting ? 'Verifying...' : 'Verify' }}
		</button>

		<!-- Close on lockout -->
		<button mat-raised-button
				*ngIf="currentStep === 'contact-admin'"
				(click)="dialogRef.close({ success: false })">
			Close
		</button>
	</mat-dialog-actions>
</div>
